import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { api } from 'helpers/services/ApiService'
import { useDispatch, useSelector } from 'react-redux'
import landingPageReducer from './slices/landingPageSlice'
import masterDataPageReducer from './slices/masterDataPageSlice'
import refreshReducer from './slices/refreshSlice'
import allocationReducer from './slices/allocationSlice'
import allocationSummaryReducer from './slices/allocationSummarySlice'
import commonReducer from './slices/commonSlice'
import supplyActualsReducer from './slices/supplyActualsSlice'
import userDetailsReducer from './slices/userDetailSlice'

// import logger from 'redux-logger'

const rootReducer = combineReducers({
  landing: landingPageReducer,
  masterData: masterDataPageReducer,
  allocation: allocationReducer,
  allocationSummary: allocationSummaryReducer,
  supplyActuals: supplyActualsReducer,
  [api.reducerPath]: api.reducer,
  refresh: refreshReducer,
  common: commonReducer,
  userDetails: userDetailsReducer,
})

export const store = configureStore({
  reducer: rootReducer,
  // devTools: import.meta.env.DEV,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      // .concat(logger)
      .concat(api.middleware),
})

export const useAppDispatch = () => useDispatch()
export const useAppSelector = useSelector
export default store
